const LAST_UPDATED_SET = 'LAST_UPDATED_SET';
const LAST_UPDATED_UPDATING = 'LAST_UPDATED_UPDATING';
const LAST_UPDATED_NO_NEW = 'LAST_UPDATED_NO_NEW';

export const lastUpdatedReducer = (state = {
    id: 2,
    time: null,
    status: null
}, action) => {
    switch (action.type) {
        case LAST_UPDATED_SET:
            return {...action.payload, status: null};
        case LAST_UPDATED_NO_NEW:
            return {...state, status: 'no-new'};
        case LAST_UPDATED_UPDATING:
            return {...state, status: 'updating'};
        default:
            return state;
    }
};

export const setLastUpdatedAction = (payload) => ({
    type: LAST_UPDATED_SET,
    payload
});

export const setLastUpdatedUpdatingAction = () => ({
    type: LAST_UPDATED_UPDATING
});
export const setLastUpdatedNoNewAction = () => ({
    type: LAST_UPDATED_NO_NEW
});
